import React, { useEffect, useState } from 'react'
import { Accordion } from 'react-bootstrap'
import { BaseUrl } from '../helper/BaseUrl';
import { useLocation } from 'react-router-dom';

export default function GlobalFaq() {
 const [activeIndex, setActiveIndex] = useState(null);
  const [data, setData] = useState(null);
  const location = useLocation();
  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const pageUrl = `https://catalyze.co.in${location.pathname}`;

        const response = await fetch(`${BaseUrl}/api/faq-by-url`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ url: pageUrl }),
        });

        const result = await response.json();

        setData(result?.faq || null);
      } catch (error) {
        console.error("FAQ fetch error:", error.message);
      }
    };

    fetchFaq();
  }, [location.pathname]);

  return (
    <>

      {data?.faqs?.length > 0 && (
        <div className="global-faq-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <div className="faq-title">Frequently Asked Questions</div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <Accordion activeKey={String(activeIndex)}
                  onSelect={(eventKey) => setActiveIndex(Number(eventKey))} className="custom-faq"  >
                  {data.faqs.map((faq, index) => (
                    <Accordion.Item eventKey={String(index)}
                      key={index} className={`accordion-items ${activeIndex === index ? "active" : ""}`} >
                      <Accordion.Header>
                        {faq.question}
                      </Accordion.Header>
                      <Accordion.Body>
                        {faq.answer?.includes("<") ? (
                          <div dangerouslySetInnerHTML={{ __html: faq.answer, }} />
                        ) : (<p>{faq.answer}</p>)}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  )
}
